import {
  Button,
  chakra,
  InputGroup,
  InputRightElement,
  useDisclosure,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { CalendarDate } from "@internationalized/date";
import { CloseIcon } from "@saas-ui/core";
import { DatePickerModal, DateValue } from "@saas-ui/date-picker";
import { useState } from "react";

const toCalendarDate = (value: string) => {
  return new CalendarDate(
    parseInt(value.slice(0, 4)),
    parseInt(value.slice(5, 7)),
    parseInt(value.slice(8, 10))
  );
};

export function FormDate({
  value,
  onChange,
  isDisabled,
  name,
  isRequired,
}: {
  value?: string;
  onChange: (date?: string) => void;
  isDisabled?: boolean;
  name?: string;
  isRequired?: boolean;
}) {
  const disclosure = useDisclosure();
  const [dateValue, setDateValue] = useState<DateValue | null>(
    !!value ? toCalendarDate(value) : null
  );
  const styles = useMultiStyleConfig("SuiSelect", {});
  /* @ts-ignore */
  const focusStyles = styles.field?._focusVisible;
  /* @ts-ignore */
  const disabledStyles = styles.field?._disabled;

  const height = styles.field?.h || styles.field?.height;
  const buttonStyles: any = {
    fontWeight: "normal",
    textAlign: "left",
    color: "inherit",
    minH: height,
    minW: 0,
    ...styles.field,
    h: "auto",
    display: "inline-flex",
  };

  const onClear = () => {
    setDateValue(null);
    onChange(undefined);
  };

  return (
    <>
      <InputGroup>
        <input
          id={`form-field-${name}`}
          className="hidden"
          value={value || ""}
          onChange={() => {}}
          name={name}
          required={isRequired}
          disabled={isDisabled}
        />
        <Button
          data-cy={``}
          textAlign="start"
          className="justify-start"
          disabled={isDisabled}
          onClick={disclosure.onOpen}
          sx={{
            ...buttonStyles,
            ...(disclosure.isOpen ? { ...focusStyles } : {}),
            ...(isDisabled ? { ...disabledStyles } : {}),
          }}
        >
          <chakra.span
            __css={{
              display: "block",
              pointerEvents: "none",
              flex: "1 1 auto",
              minW: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dateValue ? dateValue.toString() : "yyyy-mm-dd"}
          </chakra.span>
        </Button>
        {!isDisabled && (
          <InputRightElement>
            <CloseIcon className="cursor-pointer" onClick={onClear} />
          </InputRightElement>
        )}
      </InputGroup>
      <DatePickerModal
        {...disclosure}
        value={dateValue}
        onChange={setDateValue}
        onSubmit={(v) => {
          onChange(v?.toString());
        }}
      />
    </>
  );
}
